
import React, { useState, useEffect, useCallback } from "react";
import "./FoodProfile.css";
import bannerimge from "../Caterings/food.jpg";
import Aboutmaamaas from "../../Modules/HomeManagment/Food/Aboutmaamaas";
import MissionVisionCards from "../../Modules/HomeManagment/Food/MissionVisionCards";
import LeadershipCard from "../../Modules/HomeManagment/Food/LeadershipCard";
import GalleryCards from "../../Modules/HomeManagment/Food/GalleryCards";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";

import { useLoader } from "../../../context/LoaderProvider.jsx";
import { imageValidationRules } from "../../../utils/imageValidationConfig.js";

import { FaInstagram, FaYoutube, FaLinkedin, FaFacebook, FaTwitter } from "react-icons/fa";

const getRegisteredName = () => {
  const vendorId = localStorage.getItem("vendorId");
  const vendorData = localStorage.getItem(`vendorData_${vendorId}`);
  if (vendorData) {
    try {
      const parsedData = JSON.parse(vendorData);
      return parsedData.registeredName || "";
    } catch {
      return "";
    }
  }
  return "";
};

const CompanyBanner = () => {
  const { showLoader, hideLoader } = useLoader();

  const [isOpen, setIsOpen] = useState(false);
  const [bannerFile, setBannerFile] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [currentBannerId, setCurrentBannerId] = useState(null);
  const [hasBannerData, setHasBannerData] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(null);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const [companyData, setCompanyData] = useState({
    name: "", // Remove getRegisteredName() call here
    since: "",
    banner: bannerimge,
    logo: "https://cdn-icons-png.flaticon.com/512/2921/2921822.png",
    openTime: "09:00 AM",
    closeTime: "10:00 PM",
    social: {
      instagram: "",
      youtube: "",
      linkedin: "",
      facebook: "",
      twitter: "",
      whatsapp: ""
    }
  });

  const [tempData, setTempData] = useState(companyData);

  const showNotification = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity
    });
    setTimeout(() => {
      setSnackbar(prev => ({ ...prev, open: false }));
    }, 3000);
  };

  // ================= FETCH BANNER =================
  const fetchBannerData = useCallback(async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) return;

    try {
      const res = await fetch(
        `https://backend.maamaas.com/food/api/banner/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const getRegisteredNameFromStorage = () => {
        const vendorData = localStorage.getItem(`vendorData_${vendorId}`);
        if (vendorData) {
          try {
            const parsedData = JSON.parse(vendorData);
            return parsedData.registeredName || "";
          } catch {
            return " ";
          }
        }
        return " ";
      };

      // Check if response is not OK or if it's an error
      if (!res.ok) {
        // No banner data exists - this is first time setup
        setHasBannerData(false);
        setCurrentBannerId(null);
        setCompanyData(prev => ({
          ...prev,
          name: getRegisteredNameFromStorage(),
          since: "",
          banner: bannerimge,
          logo: "https://cdn-icons-png.flaticon.com/512/2921/2921822.png",
          social: {
            instagram: "",
            youtube: "",
            linkedin: "",
            facebook: "",
            twitter: "",
            whatsapp: ""
          }
        }));
        return;
      }

      const data = await res.json();

      // Check if we have valid banner data
      if (data && data.bannerId) {
        setHasBannerData(true);
        setCurrentBannerId(data.bannerId);

        setCompanyData(prev => ({
          ...prev,
          name: data.companyName || getRegisteredNameFromStorage(),
          since: data.establishedYear || "",
          banner: data.companyBanner || prev.banner,
          logo: data.companyLogo || prev.logo,
          social: {
            instagram: data.instagramLink || "",
            youtube: data.youtubeLink || "",
            linkedin: data.linkedinLink || "",
            facebook: data.facebookLink || "",
            twitter: data.twitterLink || "",
            whatsapp: data.whatsappLink || ""
          }
        }));
      } else {
        setHasBannerData(false);
      }

    } catch (err) {
      console.error("Banner fetch error", err);
      // On error, assume no banner data exists
      setHasBannerData(false);
      setCurrentBannerId(null);
    }
  }, []);

  useEffect(() => {
    fetchBannerData();
  }, [fetchBannerData]);

  // ================= MODAL =================
  const openModal = () => {
    setTempData(companyData);
    setBannerFile(null);
    setLogoFile(null);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  // ================= INPUT =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTempData({ ...tempData, [name]: value });
  };

  const handleSocialChange = (e) => {
    const { name, value } = e.target;
    setTempData({
      ...tempData,
      social: {
        ...tempData.social,
        [name]: value
      }
    });
  };

  // ================= IMAGE UPLOAD =================
  const handleImageUpload = async (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      showNotification("Image size should be less than 5MB", "error");
      return;
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
      showNotification("Please upload an image file", "error");
      return;
    }

    setUploadingImage(field);

    try {
      const url = URL.createObjectURL(file);
      setTempData({ ...tempData, [field]: url });

      if (field === "banner") setBannerFile(file);
      if (field === "logo") setLogoFile(file);

      showNotification(`${field === "banner" ? "Banner" : "Logo"} selected successfully!`, "success");
    } catch (error) {
      showNotification("Error uploading image", "error");
    } finally {
      setUploadingImage(null);
    }
  };

  const removeImage = (field) => {
    if (field === "banner") {
      setBannerFile(null);
      setTempData({ ...tempData, banner: companyData.banner });
    } else if (field === "logo") {
      setLogoFile(null);
      setTempData({ ...tempData, logo: companyData.logo });
    }
    showNotification(`${field === "banner" ? "Banner" : "Logo"} image reset`, "info");
  };

  // ================= SAVE =================
  const saveChanges = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) {
      showNotification("Session expired", "error");
      return;
    }

    showLoader();

    try {
      const isEditing = hasBannerData && !!currentBannerId;

      const url = isEditing
        ? `https://backend.maamaas.com/food/api/vendor/banner/edit/${currentBannerId}`
        : `https://backend.maamaas.com/food/api/vendor/banner/add/${vendorId}`;

      const bannerData = {
        bannerId: currentBannerId || 0,
        companyName: tempData?.name ?? "",
        establishedYear: tempData?.since || "",
        whatsappLink: tempData?.social?.whatsapp ?? "",
        instagramLink: tempData?.social?.instagram ?? "",
        facebookLink: tempData?.social?.facebook ?? "",
        twitterLink: tempData?.social?.twitter ?? "",
        youtubeLink: tempData?.social?.youtube ?? "",
        linkedinLink: tempData?.social?.linkedin ?? ""
      };

      const formData = new FormData();
      formData.append(
        "bannerData",
        new Blob([JSON.stringify(bannerData)], { type: "application/json" })
      );

      if (bannerFile) {
        formData.append("companyBanner", bannerFile);
      }

      if (logoFile) {
        formData.append("companyLogo", logoFile);
      }

      const res = await fetch(url, {
        method: isEditing ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      if (!res.ok) {
        const errorData = await res.text();
        showNotification(errorData || "Upload failed", "error");
        hideLoader();
        return;
      }

      setCompanyData(tempData);
      setIsOpen(false);
      await fetchBannerData();
      showNotification(isEditing ? "Company info updated successfully!" : "Company info created successfully!", "success");

    } catch (err) {
      console.error(err);
      showNotification("Network error", "error");
    } finally {
      hideLoader();
    }
  };

  // ================= UI =================
  return (
    <>
      <div className="company-banner-wrapper">
        <div
          className="banner"
          style={{ backgroundImage: `url(${companyData.banner})` }}
        >
          <div className="banner-overlay">
            <div className="banner-left">
              <img
                src={companyData.logo}
                alt="logo"
                className="company-logo"
              />
              <div className="company-info">
                <h2>{companyData.name}</h2>
                {companyData.since && <p>Since {companyData.since}</p>}
              </div>
            </div>
            <div className="info-actions">
              {/* <div className="time-badge">
                <span className="status-dot"></span>
                Open • {companyData.openTime} - {companyData.closeTime}
              </div> */}
              <button className="edit-btn" onClick={openModal}>
                {hasBannerData ? "Edit Info" : "Add Info"}
              </button>
            </div>
          </div>

          <div className="banner-bottom">
            <div className="banner-social">
              <a
                href={companyData.social.instagram || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.instagram ? "disabled" : ""}
              >
                <FaInstagram />
              </a>
              <a
                href={companyData.social.youtube || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.youtube ? "disabled" : ""}
              >
                <FaYoutube />
              </a>
              <a
                href={companyData.social.linkedin || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.linkedin ? "disabled" : ""}
              >
                <FaLinkedin />
              </a>
              <a
                href={companyData.social.facebook || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.facebook ? "disabled" : ""}
              >
                <FaFacebook />
              </a>
              <a
                href={companyData.social.twitter || "#"}
                target="_blank"
                rel="noreferrer"
                className={!companyData.social.twitter ? "disabled" : ""}
              >
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

        {/* IMPROVED EDIT MODAL */}
        <Dialog
          open={isOpen}
          onClose={closeModal}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "16px",
              overflow: "hidden"
            }
          }}
        >
          <DialogTitle sx={{
            borderBottom: "1px solid #e0e0e0",
            pb: 2,
            // bgcolor: "#f8f9fa",
            fontSize: "1.5rem",
            fontWeight: 600,
            color: "#333"
          }}>
            {hasBannerData ? "Edit Company Info" : "Add Company Info"}
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: "#ffffff",
                // '&:hover': {
                //   color: "#333",
                //   bgcolor: "#f0f0f0"
                // }
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ pt: 3, pb: 2 }}>
            <Grid container spacing={3}>
              {/* Banner and Logo - Side by Side */}
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  {/* Banner Upload Section */}
                  <Grid item xs={12} sm={7}>
                    <Typography variant="subtitle1" fontWeight="600" mb={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CloudUploadIcon sx={{ fontSize: 20, color: "#e66d33" }} />
                      Banner Image

                    </Typography>
                    <Box
                      sx={{
                        // border: (tempData.banner && tempData.banner !== bannerimge) ? "2px solid #4caf50" : "2px dashed #ddd",
                        borderRadius: "16px",
                        p: 2,
                        textAlign: "center",
                        position: "relative",
                        backgroundColor: (tempData.banner && tempData.banner !== bannerimge) ? "#f8fff8" : "#fafafa",
                        minHeight: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        '&:hover': {
                          borderColor: "#e66d33",
                          backgroundColor: "#fff8f5",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                        }
                      }}
                      onClick={() => document.getElementById('banner-upload-input').click()}
                    >
                      {(tempData.banner && tempData.banner !== bannerimge) || (bannerFile) ? (
                        <>
                          <img
                            src={bannerFile ? URL.createObjectURL(bannerFile) : tempData.banner}
                            alt="Banner preview"
                            style={{
                              width: "100%",
                              maxHeight: "140px",
                              objectFit: "cover",
                              borderRadius: "12px",
                              marginBottom: "12px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                            }}
                          />
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                            sx={{
                              borderRadius: "20px",
                              textTransform: "none",
                              borderColor: "#e66d33",
                              color: "#e66d33",
                              '&:hover': {
                                borderColor: "#d55a2a",
                                backgroundColor: "#fff0e8"
                              }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            Change Banner
                            <input
                              id="banner-upload-input"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "banner")}
                            />
                          </Button>
                        </>
                      ) : (
                        <>
                          <CloudUploadIcon sx={{ fontSize: 48, color: "#ccc", mb: 1 }} />
                          <Typography variant="body1" fontWeight="500" color="text.secondary" sx={{ mb: 0.5 }}>
                            Click to upload banner
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Recommended: 1920x400px • Max 5MB
                          </Typography>
                          <Button
                            variant="contained"
                            component="label"
                            startIcon={uploadingImage === "banner" ? <CircularProgress size={16} /> : <CloudUploadIcon />}
                            disabled={uploadingImage === "banner"}
                            size="small"
                            sx={{
                              mt: 2,
                              bgcolor: "#e66d33",
                              borderRadius: "20px",
                              textTransform: "none",
                              '&:hover': { bgcolor: "#d55a2a" }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {uploadingImage === "banner" ? "Uploading..." : "Upload Banner"}
                            <input
                              id="banner-upload-input"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "banner")}
                            />
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>

                  {/* Logo Upload Section */}
                  <Grid item xs={12} sm={5}>
                    <Typography variant="subtitle1" fontWeight="600" mb={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ImageIcon sx={{ fontSize: 20, color: "#e66d33" }} />
                      Company Logo

                    </Typography>
                    <Box
                      sx={{
                        // border: (tempData.logo && tempData.logo !== "https://cdn-icons-png.flaticon.com/512/2921/2921822.png") ? "2px solid #4caf50" : "2px dashed #ddd",
                        borderRadius: "16px",
                        p: 2,
                        textAlign: "center",
                        backgroundColor: (tempData.logo && tempData.logo !== "https://cdn-icons-png.flaticon.com/512/2921/2921822.png") ? "#f8fff8" : "#fafafa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        minHeight: "215px",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        '&:hover': {
                          borderColor: "#e66d33",
                          backgroundColor: "#fff8f5",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                        }
                      }}
                      onClick={() => document.getElementById('logo-upload-input').click()}
                    >
                      {(tempData.logo && tempData.logo !== "https://cdn-icons-png.flaticon.com/512/2921/2921822.png") || (logoFile) ? (
                        <>
                          <img
                            src={logoFile ? URL.createObjectURL(logoFile) : tempData.logo}
                            alt="Logo preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "contain",
                              borderRadius: "12px",
                              marginBottom: "12px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                            }}
                          />
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<ImageIcon />}
                            size="small"
                            sx={{
                              borderRadius: "20px",
                              textTransform: "none",
                              borderColor: "#e66d33",
                              color: "#e66d33",
                              '&:hover': {
                                borderColor: "#d55a2a",
                                backgroundColor: "#fff0e8"
                              }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            Change Logo
                            <input
                              id="logo-upload-input"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "logo")}
                            />
                          </Button>
                        </>
                      ) : (
                        <>
                          <ImageIcon sx={{ fontSize: 48, color: "#ccc", mb: 1 }} />
                          <Typography variant="body1" fontWeight="500" color="text.secondary" sx={{ mb: 0.5 }}>
                            Click to upload logo
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Square image • Max 2MB
                          </Typography>
                          <Button
                            variant="contained"
                            component="label"
                            startIcon={uploadingImage === "logo" ? <CircularProgress size={16} /> : <ImageIcon />}
                            disabled={uploadingImage === "logo"}
                            size="small"
                            sx={{
                              mt: 2,
                              bgcolor: "#e66d33",
                              borderRadius: "20px",
                              textTransform: "none",
                              '&:hover': { bgcolor: "#d55a2a" }
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {uploadingImage === "logo" ? "Uploading..." : "Upload Logo"}
                            <input
                              id="logo-upload-input"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, "logo")}
                            />
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Company Details - Name and Since Year Side by Side */}
              <Grid item xs={12}>
                {/* <Typography variant="subtitle1" fontWeight="600" mb={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  Company Details
                </Typography> */}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Company Name"
                      name="name"
                      value={tempData.name}
                      onChange={handleChange}

                      fullWidth
                      required
                      InputProps={{
                        sx: { borderRadius: "10px" }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Since Year"
                      name="since"
                      value={tempData.since}
                      onChange={handleChange}
                      fullWidth
                      placeholder="e.g., 2020"
                      InputProps={{
                        sx: { borderRadius: "10px" }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Social Media Links */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="600" mb={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  Social Media Links
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Instagram"
                      name="instagram"
                      value={tempData.social.instagram}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://instagram.com/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.instagram && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="YouTube"
                      name="youtube"
                      value={tempData.social.youtube}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://youtube.com/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.youtube && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="LinkedIn"
                      name="linkedin"
                      value={tempData.social.linkedin}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://linkedin.com/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.linkedin && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Facebook"
                      name="facebook"
                      value={tempData.social.facebook}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://facebook.com/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.facebook && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Twitter"
                      name="twitter"
                      value={tempData.social.twitter}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://twitter.com/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.twitter && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="WhatsApp"
                      name="whatsapp"
                      value={tempData.social.whatsapp}
                      onChange={handleSocialChange}
                      fullWidth
                      placeholder="https://wa.me/..."
                      InputProps={{
                        sx: { borderRadius: "10px" },
                        startAdornment: tempData.social.whatsapp && (
                          <span style={{ marginRight: "8px", fontSize: "20px" }}></span>
                        )
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{
            p: 2,
            borderTop: "1px solid #e0e0e0",
            bgcolor: "#f8f9fa",
            gap: 2
          }}>
            <Button
              onClick={closeModal}
              variant="outlined"
              sx={{
                borderRadius: "10px",
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 500
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={saveChanges}
              sx={{
                borderRadius: "10px",
                px: 3,
                py: 1,
                textTransform: "none",
                fontWeight: 500,
                bgcolor: "#e66d33",
                '&:hover': { bgcolor: "#d55a2a" }
              }}
            >
              {hasBannerData ? "Save Changes" : "Submit"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Aboutmaamaas />
      <MissionVisionCards />
      {window.innerWidth > 1440 &&
        <LeadershipCard />}
      <GalleryCards />

      {/* Snackbar Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ borderRadius: "10px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CompanyBanner;